const storagePrefix = "estorelogistics"
const REACT_APP_VERSION = "2.0.0"

export const storageName = {
  user: `${storagePrefix}:user`,
  productList: `${storagePrefix}:product-list`,
  filterCriteria: `${storagePrefix}:filter-criteria`,
  activeCompany: `${storagePrefix}:active-company`,
  salesOrderFilter: `${storagePrefix}${REACT_APP_VERSION}:so-filter`,
  salesOrderColumn: `${storagePrefix}${REACT_APP_VERSION}:so-column`,
  returnsFilter: `${storagePrefix}${REACT_APP_VERSION}:returns-filter`,
  returnsColumn: `${storagePrefix}${REACT_APP_VERSION}:returns-column`,
  inboundFilter: `${storagePrefix}${REACT_APP_VERSION}:inbound-filter`,
  inboundColumn: `${storagePrefix}${REACT_APP_VERSION}:inbound-column`,
  inboundProductColumn: `${storagePrefix}${REACT_APP_VERSION}:inbound-product-column`,
  inventoryFilter: `${storagePrefix}${REACT_APP_VERSION}:inventory-filter`,
  inventoryColumn: `${storagePrefix}${REACT_APP_VERSION}:inventory-column`,
  inventoryMovementColumn: `${storagePrefix}${REACT_APP_VERSION}:inventory-movement-column`,
  inventoryViewFilter: `${storagePrefix}${REACT_APP_VERSION}:inventory-view-filter`,
  inventoryViewColumn: `${storagePrefix}${REACT_APP_VERSION}:inventory-view-column`,
  importFileNameSalesOrder: `${storagePrefix}${REACT_APP_VERSION}:import-file-name-so`,
  importedSalesOrder: `${storagePrefix}${REACT_APP_VERSION}:imported-so`,
  importedSalesOrderColumns: `${storagePrefix}${REACT_APP_VERSION}:imported-so-columns`,
  importedSalesOrderValidation: `${storagePrefix}${REACT_APP_VERSION}:imported-so-validation`,
  importFileNameInbound: `${storagePrefix}${REACT_APP_VERSION}:import-file-name-inbound`,
  importedInbound: `${storagePrefix}${REACT_APP_VERSION}:imported-inbound`,
  importFileNameInventory: `${storagePrefix}${REACT_APP_VERSION}:import-file-name-inventory`,
  importedInventory: `${storagePrefix}${REACT_APP_VERSION}:imported-inventory`,
  importedInventoryColumns: `${storagePrefix}${REACT_APP_VERSION}:imported-inv-columns`,
  bomFilter: `${storagePrefix}${REACT_APP_VERSION}:bom-filter`,
  bomColumn: `${storagePrefix}${REACT_APP_VERSION}:bom-column`,
  dgItemProfileFilter: `${storagePrefix}${REACT_APP_VERSION}:dgItemProfile-filter`,
  dgItemProfileColumn: `${storagePrefix}${REACT_APP_VERSION}:dgItemProfile-column`,
  inventoryNavGroupCls: `${storagePrefix}${REACT_APP_VERSION}:inventoryNavGroupCls`,
  inventoryNavGroupActive: `${storagePrefix}${REACT_APP_VERSION}:inventoryNavGroupActive`,
  uploadHistoryFilter: `${storagePrefix}${REACT_APP_VERSION}:uploadHistory-filter`,
  uploadHistoryColumn: `${storagePrefix}${REACT_APP_VERSION}:uploadHistory-column`,
  importingModule: `${storagePrefix}${REACT_APP_VERSION}:importing-module`,
}
